export const API_PREFIX = '/rest/$designer';
export const EXT_API_PREFIX = '/rest/$designer-ext';

export function transformDates<T extends { [key: string]: any }>(
  ...dateAttrs: string[]
) {
  return (obj: T): T => {
    if (dateAttrs.length === 0) {
      return obj;
    }

    const result: {
      [key: string]: any;
    } = { ...obj };

    dateAttrs.forEach((attr) => {
      if (typeof result[attr] !== 'string') {
        return;
      }

      result[attr] = new Date(result[attr]);
    });

    return result as T;
  };
}

export class HTTPError extends Error {
  constructor(
    public url: string,
    public response: Response,
    public data?: any,
  ) {
    super();
  }

  log() {
    console.error('Error while sending the request', this);
  }
}

export async function http<T>(url: string, request: RequestInit): Promise<T> {
  const response = await window.fetch(url, request);

  if (/401/.test(response.status.toString())) {
    window.location.href = '/login.html?redirect=studio';
  }

  if (/^[45]/.test(response.status.toString())) {
    let error: HTTPError;
    try {
      const body = await response.json();
      error = new HTTPError(url, response, body);
    } catch (e) {
      error = new HTTPError(url, response);
    }

    error.log();
    throw error;
  }
  const body = await response.json();
  return body;
}
